export enum StoredFields {
  IMAGE_DISCLAIMER = 'image-disclaimer',
  VARIATION_DISCLAIMER = 'variation-disclaimer',
  ONE_LOGIN_USER = 'one-login-user',
  LANDING_ROUTE = 'landing-route',
  USER_ID = 'user-id',
}
